import Vue from 'vue'
import Vuex from 'vuex'
import * as ACTIONS from '../actions'
import * as MUTATIONS from '../mutations'
import API from '../../services/api'

Vue.use(Vuex)

export default {
	state: {
		list: [],
	},
	mutations: {
		[MUTATIONS.COMMENT.LIST](state, list) {
			state.list = list
		},
		[MUTATIONS.COMMENT.EXPAND](state) {
			state.list.forEach(comment => {
				comment.show = true
			})
		},

		[MUTATIONS.COMMENT.HIDE](state) {
			state.list.forEach(comment => {
				comment.show = false
			})
		},

		[MUTATIONS.COMMENT.ANALYSIS](state, analysis) {
			let result = state.list.find(c => {
				return c.id === analysis.commentId
			})

			const idx = state.list.indexOf(result)

			if (idx > -1) {
				result.show = true
				result.loading = false
				result.analysisId = analysis.id
				result.magnitude = analysis.magnitude
				result.score = analysis.score
				result.language = analysis.language
				result.sentences = analysis.sentences
				Vue.set(state.list, idx, result)
			}
		},
	},
	actions: {
		[ACTIONS.COMMENT.LIST]({ commit, dispatch, state }, filter = {}) {
			return API.COMMENT.LIST(filter).then(res => {
				res.forEach(comment => {
					comment.show = false
					comment.loading = false
				})
				commit(MUTATIONS.COMMENT.LIST, res)
				return res
			})
		},
		[ACTIONS.COMMENT.ANALYSIS]({ commit, dispatch, state }, { id }) {
			return API.COMMENT.ANALYSIS({ commentId: id }).then(res => {
				commit(MUTATIONS.COMMENT.ANALYSIS, res)
				return res
			})
		},
	},

	getters: {
		getCommentList: state => state.list,
	},
}
